import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import CircularProgress from "@mui/material/CircularProgress";

const Projects = () => {
  const navigate = useNavigate();
  const backHome = () => {
    navigate("/");
  };
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchProjects = async () => {
    try {
      const response = await fetch("./Projects.json");
      const projects = await response.json();
      setProjects(projects);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  if (loading) {
    return (
      <div className="bg-[#111] text-white min-h-screen flex items-center justify-center">
        <CircularProgress style={{ color: "#009e66" }} />
      </div>
    );
  }

  return (
    <div className="bg-[#111] text-white min-h-screen p-4">
      <div className="absolute right-14 top-7 max-md:right-6 max-md:top-4">
        <button
          onClick={backHome}
          className="relative p-2 after:border-2 after:border-[#009e66] after:w-4/5 after:h-4/5 after:animate-ping after:ease-out after:absolute after:rounded-full after:right-1 after:top-1"
        >
          <CloseIcon sx={{ fontSize: "38px", color: "#009e66" }} />
        </button>
      </div>
      <div className="container mx-auto pt-20">
        <h1 className="text-4xl font-bold text-center mb-8">My Projects</h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project) => (
            <div
              key={project.id}
              className="bg-[#1c1c1c] p-6 rounded-lg shadow-lg hover:scale-105 transition-all duration-300"
            >
              <img
                src={project.image}
                alt={project.name}
                className="w-full h-48 object-cover rounded mb-4"
              />
              <div className="flex flex-col  lg:h-72 md:h-80  justify-between">
                <div className="flex-grow">
                  <h2 className="text-2xl font-bold mb-2">{project.name}</h2>
                  <p className="text-gray-400 mb-4">{project.description}</p>

                  <ul className="mb-4">
                    {project.features.map((feature, index) => (
                      <li
                        key={index}
                        className="text-sm text-gray-400 list-disc ml-4"
                      >
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="flex flex-wrap gap-2 mb-4">
                  {project.tech.map((tech, index) => (
                    <span
                      key={index}
                      className="text-xs   text-white px-2 py-1 rounded cursor-pointer bg-[#009e66] hover:bg-[#007d52] transition-all duration-300"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
                <div className="flex justify-between ">
                  {project.clientgithub && (
                    <a
                      href={project?.clientgithub}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#009e66] hover:underline"
                    >
                      Client Code
                    </a>
                  )}

                  {project.servergithub && (
                    <a
                      href={project.servergithub}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#009e66] hover:underline"
                    >
                      Server Code
                    </a>
                  )}
                  {project.gitRepository && (
                    <a
                      href={project.gitRepository}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#009e66] hover:underline"
                    >
                      Git Repository
                    </a>
                  )}
                  <a
                    href={project.live}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#009e66] hover:underline"
                  >
                    Live Demo
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
